import { Box, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ColorScheme } from "../../Themes/ColorScheme";
import { ApiContext } from "../ApiContext";
import TooltipWrapper from "../Common/TooltipWrapper";

export const HideLocation = ({ location }) => {

	const { ApiCall } = useContext(ApiContext);
	const { t } = useTranslation();

	const [hidden, setHidden] = useState(true);

	useEffect(() => {
		let isHidden = location.is_hidden;
		let hasCharging = location?.location_permissions?.some(perm => perm.permission_id === 7);
		let hasWebsite = location?.website != null;

		if (!isHidden) {
			setHidden(false);
		} else {
			setHidden(true);
		}

	}, [location]);

	return (
		<Stack direction="row" spacing={2}>
			<TooltipWrapper
				title={
					hidden
						? t("location.hidden_from_all_tooltip")
						: t("location.visible_to_all_tooltip")
				}
			>
				<Box
					sx={{
						backgroundColor: hidden
							? ColorScheme.dangerSecondary
							: ColorScheme.successSecondary,
						borderRadius: "4px",
						border: `1px solid ${
							hidden
								? ColorScheme.dangerPrimary
								: ColorScheme.successPrimary
						}`,
						marginRight: "20px",
						padding: "5px 10px",
					}}
				>
					<Typography sx={{
						color: hidden ? ColorScheme.dangerPrimary : ColorScheme.successPrimary,
						fontSize: "10px",
						fontWeight: "700",
					}}>
						{hidden ? t("location.hidden_from_all") : t("location.visible_to_all")}
					</Typography>
				</Box>
			</TooltipWrapper>
		</Stack>
	);
};
